<template>
    <div class="col-6 m-auto">
        <card :title="id ? $t('edit_printabletype') :  $t('add_new_printabletype')">
            <form @submit.prevent="savePrintableType"
                @keydown="form.onKeydown($event)">
                <!-- Company -->
                <div class="form-group">
                    <label >{{ $t('company') }}</label>
                    
                        <select v-model="form.company_id"
                            :class="{ 'is-invalid': form.errors.has('company_id') }"
                            class="form-control"
                            name="company_id">
                            <option value="" selected>{{ $t('select_company') }}</option>
                            <option v-bind:key="company.id" v-for="company in companies" v-bind:value="company.id">
                                {{ company.name }}
                            </option>
                        </select>
                        <has-error :form="form"
                            field="company" />
                    
                </div>

                <!-- Name -->
                <div class="form-group">
                    <label >{{ $t('name') }}</label>
                    
                        <input v-model="form.name"
                            :class="{ 'is-invalid': form.errors.has('name') }"
                            class="form-control"
                            type="text"
                            name="name">
                        <has-error :form="form"
                            field="name" />
                    
                </div>

                <!-- Description -->
                <div class="form-group">
                    <label >{{ $t('description') }}</label>
                    
                        <textarea v-model="form.description"
                            :class="{ 'is-invalid': form.errors.has('description') }"
                            class="form-control"
                            name="description"></textarea>
                        <has-error :form="form"
                            field="description" />
                    
                </div>

                <!-- Bleed -->
                <div class="form-group row">
                    <div class="col-6">
                        <label>{{ $t('bleed_horizontal') }}</label>
                            <input v-model="form.bleed_horizontal"
                                :class="{ 'is-invalid': form.errors.has('bleed_horizontal') }"
                                class="form-control"
                                type="text"
                                name="bleed_horizontal">
                            <has-error :form="form"
                                field="bleed_horizontal" />
                    </div>
                    <div class="col-6">
                        <label>{{ $t('bleed_vertical') }}</label>
                            <input v-model="form.bleed_vertical"
                                :class="{ 'is-invalid': form.errors.has('bleed_vertical') }"
                                class="form-control"
                                type="text"
                                name="bleed_vertical">
                            <has-error :form="form"
                                field="bleed_vertical" />
                    </div>
                </div>

                <!-- Paper -->
                <div class="form-group row">
                    <div class="col-6">
                        <label>{{ $t('paper_width') }}</label>
                            <input v-model="form.paper_width"
                                :class="{ 'is-invalid': form.errors.has('paper_width') }"
                                class="form-control"
                                type="text"
                                name="paper_width">
                            <has-error :form="form"
                                field="paper_width" />
                    </div>
                    <div class="col-6">
                        <label>{{ $t('paper_height') }}</label>
                            <input v-model="form.paper_height"
                                :class="{ 'is-invalid': form.errors.has('paper_height') }"
                                class="form-control"
                                type="text"
                                name="paper_height">
                            <has-error :form="form"
                                field="paper_height" />
                    </div>
                </div>

                <h5 class="sub-header">{{ $t('pagination_settings') }}</h5>
                <!-- Pagination Left -->
                <div class="form-group row">
                    <div class="col-6">
                        <label>{{ $t('pagination_left_x') }}</label>
                            <input v-model="form.pagination_left_x"
                                :class="{ 'is-invalid': form.errors.has('pagination_left_x') }"
                                class="form-control"
                                type="text"
                                name="pagination_left_x">
                            <has-error :form="form"
                                field="pagination_left_x" />
                    </div>
                    <div class="col-6">
                        <label>{{ $t('pagination_left_y') }}</label>
                            <input v-model="form.pagination_left_y"
                                :class="{ 'is-invalid': form.errors.has('pagination_left_y') }"
                                class="form-control"
                                type="text"
                                name="pagination_left_y">
                            <has-error :form="form"
                                field="pagination_left_y" />
                    </div>
                </div>

                <!-- Pagination Right -->
                <div class="form-group row">
                    <div class="col-6">
                        <label>{{ $t('pagination_right_x') }}</label>
                            <input v-model="form.pagination_right_x"
                                :class="{ 'is-invalid': form.errors.has('pagination_right_x') }"
                                class="form-control"
                                type="text"
                                name="pagination_right_x">
                            <has-error :form="form"
                                field="pagination_right_x" />
                    </div>
                    <div class="col-6">
                        <label>{{ $t('pagination_right_y') }}</label>
                            <input v-model="form.pagination_right_y"
                                :class="{ 'is-invalid': form.errors.has('pagination_right_y') }"
                                class="form-control"
                                type="text"
                                name="pagination_right_y">
                            <has-error :form="form"
                                field="pagination_right_y" />
                    </div>
                </div>

                    <!-- Pagination font -->
                <div class="form-group row">
                    <div class="col-6">
                        <label>{{ $t('font') }}</label>
                            <select v-model="form.pagination_font"
                                :class="{ 'is-invalid': form.errors.has('pagination_font') }"
                                class="form-control"
                                type="text"
                                name="pagination_font">
                                <option value="Helvetica">Helvetica</option>
                                <optgroup label="DejaVu Sans">  
                                    <option value="DejaVuSans">DejaVu Sans</option>
                                    <option value="DejaVuSans-Bold">DejaVu Sans Bold</option>
                                </optgroup>
                                <optgroup label="DejaVu Serif">
                                    <option value="DejaVuSerif">DejaVu Serif</option>
                                    <option value="DejaVuSerif-Bold">DejaVu Serif Bold</option>
                                </optgroup>
                                <optgroup label="DejaVu Monospace">
                                    <option value="DejaVuSansMono">DejaVu Sans Monospace</option>
                                    <option value="DejaVuSansMono-Bold">DejaVu Sans Mono</option>
                                </optgroup>
                            </select>
                            <has-error :form="form"
                                field="pagination_font" />
                    </div>
                    <div class="col-6">
                        <label>{{ $t('fontsize') }}</label>
                            <input v-model="form.pagination_fontsize"
                                :class="{ 'is-invalid': form.errors.has('pagination_fontsize') }"
                                class="form-control"
                                type="text"
                                name="pagination_fontsize">
                            <has-error :form="form"
                                field="pagination_fontsize" />
                    </div>
                </div>

                <h5 class="sub-header">{{ $t('spread_settings') }}</h5>
                <!-- Pages per spread  -->
                <div class="form-group row">
                    <div class="col-6">
                        <label>{{ $t('pages_per_spread') }}</label>
                            <input v-model="form.pages_per_spread"
                                :class="{ 'is-invalid': form.errors.has('pages_per_spread') }"
                                class="form-control"
                                type="text"
                                name="pages_per_spread">
                            <has-error :form="form"
                                field="pages_per_spread" />
                    </div>
                    <div class="col-6">
                        <label>{{ $t('default_startpages') }}</label>
                            <input v-model="form.default_startpages"
                                :class="{ 'is-invalid': form.errors.has('default_startpages') }"
                                class="form-control"
                                type="text"
                                name="default_startpages">
                            <has-error :form="form"
                                field="default_startpages" />
                    </div>
                </div>
                <!--<div class="form-group">
                    <span class="switch">
                        <input v-model="form.start_with_rightside"
                                :class="{ 'is-invalid': form.errors.has('start_with_rightside') }"
                                class="switch"
                                type="checkbox"
                                name="start_with_rightside"
                                id="start_with_rightside">
                        <label class="form-check-label" for="start_with_rightside">
                            {{ $t('start_with_rightside') }}
                        </label>
                    </span>
                </div>-->
            </form>

            <div class="text-right" slot="footer">
                <!-- Submit Button -->
                <button class="btn btn-primary" @click="savePrintableType" :loading="form.busy">
                    {{ $t('save') }}
                </button>
            </div>
        </card>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Form from "vform";
import Modal from "~/components/Modal";

export default {
    data() {
        return {
            loading: false,
            printabletypes: null,
            companies: null,
            error: null,
            form: new Form({
                name: "",
                description: "",
                company_id: "",
                bleed_horizontal: "",
                bleed_vertical: "",
                paper_width: "",
                paper_height: "",
                pagination_left_x:"",
                pagination_left_y:"",
                pagination_right_x:"",
                pagination_right_y:"",
                pagination_fontsize:"",
                pagination_font:"DejaVuSans.ttf",
                pages_per_spread:"",
                default_startpages:"",
                start_with_rightside:true,
            })
        };
    },
    components: {
        Modal
    },
    created() {
        this.fetchData(this.id);
    },
    computed: {
        id(){
            return this.$route.params.id ? this.$route.params.id : false;
        }
    },
    methods: {
        populateForm(data){
            for(var key in data) {
                if(this.form.hasOwnProperty(key)) {
                    this.form[key] = data[key];
                }
            }
        },
        async fetchData(id) {
            this.loading = true;
            this.fetchPrintableType(id);
            this.fetchCompanies();
            this.loading = false;
        },
        async fetchPrintableType(id){
            if(id){
                let { data } = await axios.get("/api/printabletype/" + id)
                this.populateForm(data);
            }
        },
        async fetchCompanies(){
            let { data } = await axios.get("/api/company")
            this.companies = data;
        },
        async savePrintableType() {
            // Register the printabletype.
            if(this.id){
                const { data } = await this.form.patch("/api/printabletype/" + this.id);
            } else {
                const { data } = await this.form.post("/api/printabletype");
            }
            
            this.form.reset();
            this.$router.push({ name: 'admin.printabletypes' });
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/printabletypes/form.vue